<template>
    <div class="loadwrap">
        <p class="loading">
            <span class="loadingicon" :class="{'loadingiconStats':statsLoading}"></span><span class="loadingtext"
                                                                                              id="loadingWord">loading more</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'loading',
        data: function () {
            return {};
        },
        props: ['statsLoading']
    };
</script>
<style lang="less" scoped>
    .loadwrap {
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2rem;
        color: #8c9399;
        background: #eff1f4;
        text-align: center;
        margin: 0 !important;
        line-height: 2rem;
        font-size: 0.8rem;
    }

    .loadingicon {
        width: 1rem;
        height: 1rem;
        background: url(../assets/home/loading-icon.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: .5rem;
        left: 0.2rem;

        animation: rotate linear 1.2s both infinite;
        -webkit-animation: rotate linear 1.2s both infinite;
    }

    .loadingiconStats {
        background: url(../assets/stats/loading-icon-stats.png) no-repeat;
        background-size: 100% 100%;
    }

    .loading {
        width: 7rem;
        margin: 0 auto;
        height: 2rem;
        line-height: 2rem;
        position: relative;
    }

    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .loadingtext {
        text-indent: 1rem;
        display: inline-block;
        font-size: 0.8rem;
    }
</style>



// WEBPACK FOOTER //
// loading.vue?6af6ec9b